module.exports = __webpack_public_path__ + "static/sliderFour-e82015fd735f1b0abdb4a3b09d14e110.png";